import $ from 'jquery';
import keycodes from '@shopify/marketing-assets/javascripts/global/keycodes';
import A11yHelpers from '@shopify/marketing-assets/javascripts/global/a11y-helpers';

class ShopSearcher {
  nodes = {
    $searchActivator: $('.js-search-activator'),
    $searchInput: $('.js-search__input'),
    $searchInputCloseButton: $('.js-search__input-close-button'),
  };

  globalNodes = {
    $html: $('html'),
    $body: $('body'),
    $searchOverlay: $('.search__overlay'),
    $pageContainer: $('#PageContainer'),
  };

  classes = {
    searchOverlayIsOpen: 'search-overlay-is--open',
    pageHasActiveSearch: 'page--search-is-open',
  };

  constructor() {
    this.nodes.$searchActivator.on('click', this.openOverlay);
    this.nodes.$searchInputCloseButton.on('click', this.closeOverlay);
    this.nodes.$searchInput.on('keydown', this.handleKeyDown);
  }

  handleKeyDown = (evt) => {
    const key = evt.keyCode;

    if (key === keycodes.ESCAPE) {
      evt.preventDefault();
      this.closeOverlay();
    }
  };

  openOverlay = (evt) => {
    if (evt) {
      this.$lastFocusedActivator = $(evt.currentTarget);
    }

    this.globalNodes.$pageContainer.off('click').on('click', this.closeOverlay.bind(this));

    this.globalNodes.$html.addClass(this.classes.searchOverlayIsOpen);
    this.globalNodes.$body.addClass(this.classes.pageHasActiveSearch);
    this.nodes.$searchInput.focus();
    A11yHelpers.prototype.trapFocus(this.globalNodes.$searchOverlay);
  };

  closeOverlay = () => {
    if (!this.globalNodes.$body.hasClass(this.classes.pageHasActiveSearch)) {
      return;
    }

    this.globalNodes.$html.removeClass(this.classes.searchOverlayIsOpen);
    this.globalNodes.$body.removeClass(this.classes.pageHasActiveSearch);

    this.$lastFocusedActivator.focus();
    A11yHelpers.prototype.removeTrapFocus(this.globalNodes.$searchOverlay);
    this.nodes.$searchInput.val('');
  };
}

export default ShopSearcher;
